// Pure helpers for the deploy/version check (no React, no import.meta.env),
// so they can be unit-tested with plain node.

export const VERSION_FILE_NAME = 'version.json'

/** Minimum gap between two automatic reloads after a failed chunk load. */
export const PRELOAD_RELOAD_GUARD_MS = 60_000

export function buildVersionUrl(baseUrl: string, cacheBust: number | string) {
  const base = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`
  return `${base}${VERSION_FILE_NAME}?t=${encodeURIComponent(String(cacheBust))}`
}

export function parseVersionPayload(payload: unknown): string | null {
  if (!payload || typeof payload !== 'object') {
    return null
  }
  const version = (payload as { version?: unknown }).version
  if (typeof version !== 'string') {
    return null
  }
  const trimmed = version.trim()
  return trimmed ? trimmed : null
}

/** True when the deployed version is known and differs from the running build. */
export function hasNewVersion(current: string | null | undefined, deployed: string | null | undefined) {
  return Boolean(current && deployed && current !== deployed)
}

/**
 * Allows one automatic reload per guard window, so a chunk that is still missing
 * after the reload does not end in a reload loop.
 */
export function shouldReloadAfterPreloadError(
  lastReloadAt: string | null,
  now: number,
  guardMs = PRELOAD_RELOAD_GUARD_MS,
) {
  const last = lastReloadAt ? Number(lastReloadAt) : Number.NaN
  if (!Number.isFinite(last)) {
    return true
  }
  return now - last >= guardMs || now < last
}
